<template>
    <div class="bounceInRight">
        <div class="row ">
            <div class="col-md-12">
                <div class="card card-radius">
                    <div class="card-block">
                        <div class="row">
                            <div class="form-group col-md-6">
                                <label > Valor Anterior </label>
                                <pre style="text-align: justify" v-html="this.previousObject">

                                </pre>
                            </div>
                            <div class="form-group col-md-6">
                                <label > Novo Valor </label>
                                <pre style="text-align: justify" v-html="this.newObject">

                                </pre>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style>
pre {outline: 1px solid #ccc; padding: 5px; margin: 5px; }
.string { color: green; }
.number { color: darkorange; }
.boolean { color: blue; }
.null { color: magenta; }
.key { color: red; }
</style>
<script>
import SinisterHistory from './sinisterhistorydetails.js'
export default SinisterHistory
</script>



// WEBPACK FOOTER //
// src/views/private/regulation/auto/history/SinisterHistoryDetails.vue